module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag),
      expression: "flag"
    }],
    attrs: {
      "src": _vm.src
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flag),
      expression: "!flag"
    }],
    class: {
      blur: _vm.mask && !_vm.flag
    },
    attrs: {
      "src": _vm.placeImg
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-316232c8!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/global/lazyImg.vue
// module id = 717
// module chunks = 1